export const mockBundleResults = [
  {
    "search_product_result_id": "ddce0b87-e574-4a06-8460-954ce1923283",
    "product_code": "parking",
    "inventory_provider": "internal",
    "inventory_id": "11642-237754",
    "inventory_item": {
        "is_closed_user_group": false,
        "accreditations": [],
        "is_map_image_active": true,
        "description": "<p>ParkVia Man 1</p>",
        "additional_fields": {
            "inbound_flight_number": {
                "is_required": false,
                "is_show": false
            },
            "vehicle_make": {
                "is_required": false,
                "is_show": false
            },
            "inbound_airline": {
                "is_required": false,
                "is_show": false
            },
            "outbound_airport": {
                "is_required": false,
                "is_show": false
            },
            "vehicle_model": {
                "is_required": false,
                "is_show": false
            },
            "outbound_flight_number": {
                "is_required": false,
                "is_show": false
            },
            "vehicle_colour": {
                "is_required": false,
                "is_show": false
            },
            "zipcode": {
                "is_required": false,
                "is_show": false
            },
            "number_of_people_in_vehicle": {
                "is_required": false,
                "is_show": false
            },
            "inbound_terminal": {
                "is_required": false,
                "is_show": false
            },
            "is_child_seat_required": {
                "is_required": false,
                "is_show": false
            },
            "outbound_airline": {
                "is_required": false,
                "is_show": false
            },
            "phone_number": {
                "is_required": false,
                "is_show": false
            },
            "plate_number": {
                "is_required": false,
                "is_show": false
            },
            "inbound_airport": {
                "is_required": false,
                "is_show": false
            },
            "outbound_terminal": {
                "is_required": false,
                "is_show": false
            }
        },
        "product_option": {
            "name": "Meet & Greet - No transfer required",
            "code": "category_type_no_transfer"
        },
        "product_logo": {
            "src": "https://cdn.inventory.test.product.cavu-tech.com/images/1061-11642_065d7c26-e646-4eed-8434-39cdff977380.png",
            "description": "logo"
        },
        "entrance_info": "<p>ParkVia Man 1</p>",
        "is_covered": true,
        "capacity": {
            "left": 998,
            "message_threshold": null
        },
        "entry_date": "2025-09-27T09:00:00",
        "geo": {
            "latitude": 51.493308384058,
            "longitude": -0.11469182222503
        },
        "features": [
            "ParkVia Man 1"
        ],
        "is_extendable": false,
        "pii_questions": {
            "order_management": null,
            "payment": null
        },
        "upgrade": {
            "is_for_upgrade_only": false,
            "product_id": null,
            "is_available": false
        },
        "is_available": true,
        "is_customer_keeps_keys": true,
        "transfer": {
            "name": "Short walk to terminal",
            "code": "walk",
            "time": 1,
            "distance": "0.1"
        },
        "exit_info": "<p>ParkVia Man 1</p>",
        "bundles": [
            {
                "name": "ecom-3805",
                "id": 2793,
                "position": 1,
                "totals": {
                    "fees": 0,
                    "total": 165,
                    "quantity": 1,
                    "subtotal": 164.17,
                    "bundle_saving": 1,
                    "discount": 5,
                    "taxes": 0.83,
                    "currency": "GBP",
                    "exchange": null,
                    "channel_based": {
                        "total": 167.99,
                        "total_discounted": 162.99
                    }
                },
                "savings": {
                    "default_saving": {
                        "discount_currency": null,
                        "offer_type": null,
                        "discount_amount": null
                    },
                    "primary_product": {
                        "saving": null,
                        "product_id": 237754
                    },
                    "products": [
                        {
                            "saving": {
                                "type": "percentage_discount",
                                "amount": 20
                            },
                            "product_id": 179847
                        }
                    ]
                },
                "type": "basic",
                "is_cancellation_protection_auto_add": false,
                "primary_item_totals": {
                    "fees": 0,
                    "total": 160,
                    "quantity": 1,
                    "subtotal": 160,
                    "bundle_saving": 0,
                    "discount": 0,
                    "taxes": 0,
                    "currency": "GBP",
                    "exchange": null,
                    "channel_based": {
                        "total": 160,
                        "total_discounted": 160
                    }
                },
                "search_criteria": {
                    "parking": {
                        "time1": "09:00",
                        "time2": "22:00",
                        "coupon_code": "FTTEST",
                        "is_primary": true,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    },
                    "lounges": {
                        "time1": "10:00",
                        "time2": "22:00",
                        "coupon_code": "FTTEST",
                        "is_primary": false,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    },
                    "fasttrack": {
                        "time1": "09:30",
                        "time2": "21:30",
                        "coupon_code": "FTTEST",
                        "is_primary": false,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    }
                },
                "products": [
                    {
                        "inventory_id": "28867-179846",
                        "product_id": 179846,
                        "inventory_item": {
                            "images": [],
                            "is_closed_user_group": false,
                            "upgrade": null,
                            "accreditations": [],
                            "description": "<p>Security FastTrack gives you access to a dedicated lane, allowing you to pass through security quickly when flying out of Manchester Airport. Pre-book your ticket now!</p>\n<p>This FastTrack product cannot be cancelled or amended.</p>\n<p>Open from 05:00 until 20:00</p>",
                            "additional_fields": {
                                "zipcode": {
                                    "is_required": true,
                                    "is_show": true
                                },
                                "inbound_flight_number": {
                                    "is_required": false,
                                    "is_show": false
                                },
                                "phone_number": {
                                    "is_required": false,
                                    "is_show": false
                                },
                                "plate_number": {
                                    "is_required": false,
                                    "is_show": false
                                },
                                "outbound_flight_number": {
                                    "is_required": true,
                                    "is_show": true
                                }
                            },
                            "product_option": {
                                "name": "Flying Out",
                                "code": "flying_out"
                            },
                            "entrance_info": "<p>Progress to airport security where you will see signage for FastTrack. Our FastTrack passes give you access to a dedicated lane straight to the security checkpoint.</p>\n<div class=\"travel-extra__description\">\n<p>In a rush to start your trip? Pre-Book Security FastTrack now!</p>\n<p><span style='color: inherit; font-family: inherit; font-size: 1rem;'>Travelling with children? &nbsp;Please be aware that security FastTrack is not suitable for customers travelling with child transport accessories, e.g Pushchairs, car seats etc.&nbsp;<br /></span></p>\n<p>Please note, this product cannot be cancelled or amended.</p>\n</div>",
                            "capacity": {
                                "left": 100,
                                "message_threshold": null
                            },
                            "entry_date": "2025-09-27T09:30:00",
                            "features": [
                                "Reach the departure lounge quickly",
                                "Limited availability"
                            ],
                            "name": "Security FastTrack (Int.)",
                            "logo": {
                                "src": null,
                                "description": null
                            },
                            "exit_date": "2025-09-27T09:45:00",
                            "pii_questions": {
                                "order_management": null,
                                "payment": null
                            },
                            "is_featured": false,
                            "direction": "outbound"
                        },
                        "details": {
                            "exit_date": "2025-09-27T09:45:00",
                            "is_locked": null,
                            "entry_date": "2025-09-27T09:30:00",
                            "direction": "outbound"
                        },
                        "product_code": "fasttrack",
                        "inventory_provider": "internal",
                        "inventory_options": [
                            {
                                "fees": [],
                                "internal": {
                                    "mark_up": null,
                                    "tax_rules": [
                                        {
                                            "name": "VAT (Value Added Tax)",
                                            "is_inclusive": true,
                                            "amount": 20,
                                            "is_calculate_in_post": true,
                                            "id": 79746
                                        }
                                    ],
                                    "net_rate": null,
                                    "expires_at": "2025-09-24T17:52:47+00:00",
                                    "booking_request": {
                                        "inbound_flight_number": null,
                                        "channel_commission_override_type": null,
                                        "quantity": 1,
                                        "fast_track_type": "flying_out",
                                        "provider_partner_name": "MAGRES - MAN P - eCom",
                                        "check_in_type": null,
                                        "outbound_flight_number": null,
                                        "partner_id": 1592,
                                        "product_type": "fasttrack",
                                        "provider": "internal",
                                        "channel_commission_override_value": null,
                                        "product_id": 179846,
                                        "product_commission": null,
                                        "provider_data": [],
                                        "provider_id": null,
                                        "phone_country": null,
                                        "provider_commission_override_value": null,
                                        "channel_id": 220,
                                        "is_extension": false
                                    },
                                    "fee_rules": []
                                },
                                "meta": {
                                    "product_option_code": "flying_out",
                                    "direction": "outbound"
                                },
                                "cancellation_policies": [
                                    {
                                        "title": "Cancellation Policy",
                                        "message": "Non refundable up to 0 day before arrival. Please note: The booking fee is non-refundable."
                                    }
                                ],
                                "taxes": [
                                    {
                                        "name": "VAT (Value Added Tax)",
                                        "amount": 0.83,
                                        "id": 79746
                                    }
                                ],
                                "amendment_policies": [
                                    {
                                        "title": "Amendment Policy",
                                        "message": "This booking cannot be amended."
                                    }
                                ],
                                "details": {
                                    "duration": 15,
                                    "groups": {
                                        "senior": {
                                            "is_selected": false
                                        },
                                        "adult": {
                                            "age": {
                                                "min": 16
                                            },
                                            "is_selected": true,
                                            "totals": {
                                                "single_total": 5,
                                                "subtotal": 5,
                                                "quantity": 1
                                            }
                                        },
                                        "infant": {
                                            "is_selected": false,
                                            "exclude_from_capacity": false
                                        },
                                        "child": {
                                            "age": {
                                                "max": 16,
                                                "min": 3
                                            },
                                            "is_selected": true
                                        }
                                    },
                                    "cancellation_protection": {
                                        "is_available": false
                                    },
                                    "is_parent": true
                                },
                                "sub_options": [
                                    {
                                        "fees": [],
                                        "internal": {
                                            "mark_up": null,
                                            "tax_rules": [
                                                {
                                                    "name": "VAT (Value Added Tax)",
                                                    "is_inclusive": true,
                                                    "amount": 20,
                                                    "is_calculate_in_post": true,
                                                    "id": 79746
                                                }
                                            ],
                                            "net_rate": null,
                                            "expires_at": "2025-09-24T17:52:47+00:00",
                                            "booking_request": [],
                                            "fee_rules": []
                                        },
                                        "meta": {
                                            "product_option_code": "flying_out",
                                            "direction": "outbound"
                                        },
                                        "taxes": [
                                            {
                                                "name": "VAT (Value Added Tax)",
                                                "amount": 0.83,
                                                "id": 79746
                                            }
                                        ],
                                        "details": {
                                            "name": "adult",
                                            "duration": 15,
                                            "name_formatted": "Adult"
                                        },
                                        "id": 179847,
                                        "totals": {
                                            "fees": 0,
                                            "total": 5,
                                            "quantity": 1,
                                            "subtotal": 4.17,
                                            "bundle_saving": 1,
                                            "discount": 5,
                                            "taxes": 0.83,
                                            "currency": "GBP",
                                            "exchange": null,
                                            "channel_based": {
                                                "total": 5,
                                                "total_discounted": 0
                                            }
                                        },
                                        "is_available": true
                                    }
                                ],
                                "id": 179846,
                                "totals": {
                                    "fees": 0,
                                    "total": 5,
                                    "quantity": 1,
                                    "subtotal": 4.17,
                                    "bundle_saving": 1,
                                    "discount": 5,
                                    "taxes": 0.83,
                                    "currency": "GBP",
                                    "exchange": null,
                                    "channel_based": {
                                        "total": 5,
                                        "total_discounted": 0
                                    }
                                },
                                "is_available": true
                            }
                        ]
                    }
                ]
            },
            {
                "name": "T3 lounge bundle",
                "id": 2794,
                "position": 2,
                "totals": {
                    "fees": 0,
                    "total": 180,
                    "quantity": 1,
                    "subtotal": 176.67,
                    "bundle_saving": 0,
                    "discount": 0,
                    "taxes": 3.33,
                    "currency": "GBP",
                    "exchange": null,
                    "channel_based": {
                        "total": 182.99,
                        "total_discounted": 182.99
                    }
                },
                "savings": {
                    "default_saving": {
                        "discount_currency": null,
                        "offer_type": null,
                        "discount_amount": null
                    },
                    "primary_product": {
                        "saving": null,
                        "product_id": 237754
                    },
                    "products": [
                        {
                            "saving": null,
                            "product_id": 179844
                        }
                    ]
                },
                "type": "basic",
                "is_cancellation_protection_auto_add": false,
                "primary_item_totals": {
                    "fees": 0,
                    "total": 160,
                    "quantity": 1,
                    "subtotal": 160,
                    "bundle_saving": 0,
                    "discount": 0,
                    "taxes": 0,
                    "currency": "GBP",
                    "exchange": null,
                    "channel_based": {
                        "total": 160,
                        "total_discounted": 160
                    }
                },
                "search_criteria": {
                    "parking": {
                        "time1": "09:00",
                        "time2": "22:00",
                        "coupon_code": "FTTEST",
                        "is_primary": true,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    },
                    "lounges": {
                        "time1": "10:00",
                        "time2": "22:00",
                        "coupon_code": "FTTEST",
                        "is_primary": false,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    },
                    "fasttrack": {
                        "time1": "09:30",
                        "time2": "21:30",
                        "coupon_code": "FTTEST",
                        "is_primary": false,
                        "airport_code": "MAN",
                        "groups": {
                            "adult": 1
                        },
                        "language": "en-GB",
                        "date2": "2025-09-30",
                        "terminal": 69,
                        "date1": "2025-09-27"
                    }
                },
                "products": [
                    {
                        "inventory_id": "28866-179843",
                        "product_id": 179843,
                        "inventory_item": {
                            "images": [
                                {
                                    "src": "https://cdn.inventory.test.product.cavu-tech.com/images/1592-28866_5bca0bda-c0b7-47aa-86ff-1956cac030a5.png",
                                    "description": "Stevie wonder"
                                }
                            ],
                            "is_closed_user_group": false,
                            "visiting_duration": null,
                            "upgrade": null,
                            "accreditations": [],
                            "baggage_type": null,
                            "meal_type": null,
                            "description": "T3 Lounge (Int.)",
                            "additional_fields": {
                                "zipcode": {
                                    "is_required": true,
                                    "is_show": true
                                },
                                "inbound_flight_number": {
                                    "is_required": true,
                                    "is_show": true
                                },
                                "phone_number": {
                                    "is_required": true,
                                    "is_show": true
                                },
                                "plate_number": {
                                    "is_required": true,
                                    "is_show": true
                                },
                                "outbound_flight_number": {
                                    "is_required": true,
                                    "is_show": true
                                }
                            },
                            "airline_name": null,
                            "product_option": {
                                "name": "Lounge regular",
                                "code": "lounge_regular"
                            },
                            "entrance_info": "T3 Lounge (Int.)",
                            "product_logo": {
                                "src": null
                            },
                            "capacity": {
                                "left": 100,
                                "message_threshold": null
                            },
                            "entry_date": "2025-09-27T10:00:00",
                            "features": [
                                "Feature 1"
                            ],
                            "name": "T3 Lounge (Int.).",
                            "visiting_duration_message": null,
                            "logo": {
                                "src": null,
                                "description": null
                            },
                            "exit_date": "2025-09-27T11:00:00",
                            "pii_questions": {
                                "order_management": null,
                                "payment": null
                            },
                            "is_featured": false,
                            "direction": null
                        },
                        "details": {
                            "visiting_duration": null,
                            "baggage_type": null,
                            "meal_type": null,
                            "visiting_duration_message": null,
                            "exit_date": "2025-09-27T11:00:00",
                            "airline_name": null,
                            "entry_date": "2025-09-27T10:00:00",
                            "direction": null
                        },
                        "product_code": "lounges",
                        "inventory_provider": "internal",
                        "inventory_options": [
                            {
                                "fees": [],
                                "internal": {
                                    "mark_up": null,
                                    "tax_rules": [
                                        {
                                            "name": "VAT (Value Added Tax)",
                                            "is_inclusive": true,
                                            "amount": 20,
                                            "is_calculate_in_post": true,
                                            "id": 79744
                                        }
                                    ],
                                    "net_rate": null,
                                    "expires_at": "2025-09-24T17:52:47+00:00",
                                    "booking_request": {
                                        "inbound_flight_number": null,
                                        "channel_commission_override_type": null,
                                        "quantity": 1,
                                        "fast_track_type": null,
                                        "provider_partner_name": "MAGRES - MAN P - eCom",
                                        "check_in_type": "outbound",
                                        "outbound_flight_number": null,
                                        "partner_id": 1592,
                                        "product_type": "lounges",
                                        "provider": "internal",
                                        "channel_commission_override_value": null,
                                        "product_id": 179843,
                                        "product_commission": 0,
                                        "provider_data": [],
                                        "provider_id": null,
                                        "phone_country": null,
                                        "provider_commission_override_value": null,
                                        "channel_id": 220,
                                        "is_extension": false
                                    },
                                    "fee_rules": []
                                },
                                "meta": {
                                    "product_option_code": "lounge_regular",
                                    "direction": null
                                },
                                "cancellation_policies": [
                                    {
                                        "title": "Cancellation Policy",
                                        "message": "No cancellation between 72 hours and 0 hour before arrival. Please note: The booking fee is non-refundable."
                                    }
                                ],
                                "taxes": [
                                    {
                                        "name": "VAT (Value Added Tax)",
                                        "amount": 3.33,
                                        "id": 79744
                                    }
                                ],
                                "amendment_policies": [
                                    {
                                        "title": "Amendment Policy",
                                        "message": "Free amendment up to 1 day before arrival. Non-amendable between 1 day and 0 day before arrival."
                                    }
                                ],
                                "details": {
                                    "duration": 60,
                                    "groups": {
                                        "senior": {
                                            "is_selected": false
                                        },
                                        "adult": {
                                            "age": {
                                                "min": 16
                                            },
                                            "is_selected": true,
                                            "totals": {
                                                "single_total": 20,
                                                "subtotal": 20,
                                                "quantity": 1
                                            }
                                        },
                                        "infant": {
                                            "is_selected": false
                                        },
                                        "child": {
                                            "age": {
                                                "max": 16,
                                                "min": 3
                                            },
                                            "is_selected": true
                                        }
                                    },
                                    "cancellation_protection": {
                                        "cancellation_policies": [
                                            {
                                                "title": "Cancellation Policy",
                                                "message": "Free cancellation up to 24 hours before arrival. Please note: The booking fee is non-refundable."
                                            }
                                        ],
                                        "taxes": [
                                            {
                                                "name": "VAT (Value Added Tax)",
                                                "amount": 0.83,
                                                "id": 79744,
                                                "type": "inclusive"
                                            }
                                        ],
                                        "totals": {
                                            "taxes": 0.83,
                                            "total": 5,
                                            "fees": 0,
                                            "channel_based": {
                                                "total": 5
                                            },
                                            "subtotal": 4.17
                                        },
                                        "message": "For just £5.00 you can cancel your booking online up to 24 hours before the day of travel and avoid a cancellation charge.",
                                        "is_available": true
                                    },
                                    "is_parent": true
                                },
                                "sub_options": [
                                    {
                                        "fees": [],
                                        "internal": {
                                            "mark_up": null,
                                            "tax_rules": [
                                                {
                                                    "name": "VAT (Value Added Tax)",
                                                    "is_inclusive": true,
                                                    "amount": 20,
                                                    "is_calculate_in_post": true,
                                                    "id": 79744
                                                }
                                            ],
                                            "net_rate": null,
                                            "expires_at": "2025-09-24T17:52:47+00:00",
                                            "booking_request": {
                                                "inbound_flight_number": null,
                                                "channel_commission_override_type": null,
                                                "quantity": 1,
                                                "fast_track_type": null,
                                                "provider_partner_name": "MAGRES - MAN P - eCom",
                                                "check_in_type": "outbound",
                                                "outbound_flight_number": null,
                                                "partner_id": 1592,
                                                "product_type": "lounges",
                                                "provider": "internal",
                                                "channel_commission_override_value": null,
                                                "product_id": 179843,
                                                "product_commission": 0,
                                                "provider_data": [],
                                                "provider_id": null,
                                                "phone_country": null,
                                                "provider_commission_override_value": null,
                                                "channel_id": 220,
                                                "is_extension": false
                                            },
                                            "fee_rules": []
                                        },
                                        "meta": {
                                            "product_option_code": "lounge_regular",
                                            "direction": null
                                        },
                                        "taxes": [
                                            {
                                                "name": "VAT (Value Added Tax)",
                                                "amount": 3.33,
                                                "id": 79744
                                            }
                                        ],
                                        "details": {
                                            "name": "adult",
                                            "duration": 60,
                                            "name_formatted": "Adult"
                                        },
                                        "id": 179844,
                                        "totals": {
                                            "fees": 0,
                                            "total": 20,
                                            "quantity": 1,
                                            "subtotal": 16.67,
                                            "bundle_saving": 0,
                                            "discount": 0,
                                            "taxes": 3.33,
                                            "currency": "GBP",
                                            "exchange": null,
                                            "channel_based": {
                                                "total": 20,
                                                "total_discounted": 20
                                            }
                                        },
                                        "is_available": true
                                    }
                                ],
                                "id": 179843,
                                "totals": {
                                    "fees": 0,
                                    "total": 20,
                                    "quantity": 1,
                                    "subtotal": 16.67,
                                    "bundle_saving": 0,
                                    "discount": 0,
                                    "taxes": 3.33,
                                    "currency": "GBP",
                                    "exchange": null,
                                    "channel_based": {
                                        "total": 20,
                                        "total_discounted": 20
                                    }
                                },
                                "is_available": true
                            }
                        ]
                    }
                ]
            }
        ],
        "name": "ParkVia Man 1",
        "exit_date": "2025-09-30T22:00:00",
        "is_featured": false,
        "map_image": {
            "src": "https://cdn.inventory.test.product.cavu-tech.com/images/1061-11642_2bbfe9d0-dfae-419f-ac47-b6994ebf51d5.jpg"
        }
    },
    "details": {
        "exit_date": "2025-09-30T22:00:00",
        "entry_date": "2025-09-27T09:00:00"
    },
    "inventory_options": [
        {
            "fees": [],
            "meta": {
                "product_option_code": "category_type_no_transfer",
                "direction": null
            },
            "cancellation_policies": [
                {
                    "title": "Cancellation Policy",
                    "message": "Cancellable with a fee of £4 between 5 days and 1 day before arrival. Non refundable between 1 day and 0 day before arrival. Please note: The booking fee is non-refundable."
                }
            ],
            "taxes": [],
            "amendment_policies": [
                {
                    "title": "Amendment Policy",
                    "message": "Amendable with a fee of £5 between 3 days and 0 day before arrival."
                }
            ],
            "details": {
                "cancellation_protection": {
                    "is_available": false
                }
            },
            "sub_options": [],
            "id": 237754,
            "totals": {
                "fees": 0,
                "total": 160,
                "quantity": 1,
                "subtotal": 160,
                "bundle_saving": 0,
                "discount": 0,
                "taxes": 0,
                "currency": "GBP",
                "exchange": null,
                "channel_based": {
                    "total": 162.99,
                    "total_discounted": 162.99
                }
            },
            "is_available": true
        }
    ]
  }
]
